"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var searchFilterByName = function searchFilterByName(inputValue, options) {
  var filteredOptions = [];
  options.map(function (option) {
    if (option.name.toLowerCase().includes(inputValue.toLowerCase())) {
      filteredOptions.push(option);
    }
  });
  return filteredOptions;
};
var _default = searchFilterByName;
exports["default"] = _default;